// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container{
    display: flex;
    flex-direction: column;
    margin: 10% auto;
    width: 275px;
    margin-right: 150px;
    margin-top: 105px;
    background-color: rgba(0, 0, 0, 0.5);
    /* background: #000000; */
    margin-bottom: 60px !important;
    /* padding-bottom: 30px; */
    border-radius: 10px;
    height: 324px;
    /* opacity: 0.6; */
    box-shadow: 1px 1px 1px 1px rgb(251, 254, 255);
}

.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 9px;
    width: 100%;
    margin-top: 30px;
}

.text {
    color: #ffffff;
    font-size: 21px;
    font-weight: 700;
}

.inputs {
    margin-top: 35px;
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.input {
    display: flex;
    align-items: center;
    margin: auto;
    width: 215px;
    height: 26px;
    background: #eaeaea;
    border-radius: 4px;
}

.input input{
    height: 50px;
    width: 400px;
    background: transparent;
    border: none;
    outline: none;
    color: #000000;
    font-size: 11px;
}

.forgot-password{
    padding-left: 160px;
    margin-top: 10px;
    
    color: #ffff;
    font-size: 11px;
    

}

.font{
    font-size: 22px;
    margin-right: 90px;
}

.submit-container{
    display: flex;
    gap: 30px;
    margin: 60px;
}

.submit{
    display: flex;
    width: 180px;
    height: 42px;
    color: #eaeaea;
    background: hsl(195, 71%, 31%);
    font-size: 19px;
    border-radius: 50px;
    margin-top: -20px;
      
}

/* .button{
    border: none;
  color: #ffffff;
  background-color: #176B87;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 4px 2px;
  cursor: pointer;
  margin-top: -48px;
  height: 35px;
  width: 300px !important;
  border-radius: 15px;
} */

.button{
    background-color: #176B87; 
    appearance: button;
    backface-visibility: hidden;
    
    border-radius: 6px;
    border-width: 0;
    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset,rgba(50, 50, 93, .1) 0 2px 5px 0,rgba(0, 0, 0, .07) 0 1px 1px 0;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    font-family: -apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif;
    font-size: 12px;
    height: 25px;
    line-height: 1.15;
    margin: 12px 0 0;
    outline: none;
    overflow: hidden;
    padding: 0 25px;
    position: relative;
    text-align: center;
    text-transform: none;
    transform: translateZ(0);
    transition: all .2s,box-shadow .08s ease-in;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    width: 212px;
    margin-left: 35px;
    margin-top: 20px;
}

.fill{
    color: #ffffff;
    font-size: 6px;

}

.background{
    /* background-image: url(/src/components/Login/background.png); */
  background-size: cover;
  background-attachment: fixed;
  z-index: -1; 
  width: 100%;
  height: 100vh;
  padding-top: 4%; 
  object-fit: cover;
}

/* .text-toca{
    font-size: 20px;
    color: #ffffff;
    margin-top: 80px;
    margin-right: 40px;
} */

.label{
    color: #ffffff;
    margin-top: -50px;
}

.row{
    display: flex;
    height: 10%;
    align-items: center;
    margin-top: -230px;
    color: #ffffff;
    margin-left: 210px;
    font-size: 18px;
}

.row-1{
    display: flex;
    height: 10%;
    align-items: center;
    margin-top: -30px;
    color: #ffffff;
    margin-left: 212px;
    font-size: 10px;
}

.col{
    flex-basis: 50%;
}

.h1{
    font-size: 100px;
}

.p{
    font-size: 15px;
}

.logo-ykbut{
    width: 100px;
    margin-right: 190px;
    margin-top: -100px;
    
}

/* .logo{
    margin-top: -130px;
} */

.error {
    color: red;
}

@media screen and (max-width:768px)  {
    .inputs {
        width: 75%;
    }
    
}

@media screen and (max-width:480px)  {
    .inputs {
        width: 65%;
    }
    
}

.txt {
    margin-top: -52px;
    color: #ffffff;
    font-size: 12px;
}

.sidebar{
    margin-top: 60px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;;IAEhB,YAAY;IACZ,eAAe;;;AAGnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;;IAE3B,kBAAkB;IAClB,eAAe;IACf,gHAAgH;IAChH,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,yFAAyF;IACzF,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;IACxB,2CAA2C;IAC3C,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,iEAAiE;EACnE,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;GAKG;;AAEH;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;;GAEG;;AAEH;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI;QACI,UAAU;IACd;;AAEJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".container{\n    display: flex;\n    flex-direction: column;\n    margin: 10% auto;\n    width: 275px;\n    margin-right: 150px;\n    margin-top: 105px;\n    background-color: rgba(0, 0, 0, 0.5);\n    /* background: #000000; */\n    margin-bottom: 60px !important;\n    /* padding-bottom: 30px; */\n    border-radius: 10px;\n    height: 324px;\n    /* opacity: 0.6; */\n    box-shadow: 1px 1px 1px 1px rgb(251, 254, 255);\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 9px;\n    width: 100%;\n    margin-top: 30px;\n}\n\n.text {\n    color: #ffffff;\n    font-size: 21px;\n    font-weight: 700;\n}\n\n.inputs {\n    margin-top: 35px;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n}\n\n.input {\n    display: flex;\n    align-items: center;\n    margin: auto;\n    width: 215px;\n    height: 26px;\n    background: #eaeaea;\n    border-radius: 4px;\n}\n\n.input input{\n    height: 50px;\n    width: 400px;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #000000;\n    font-size: 11px;\n}\n\n.forgot-password{\n    padding-left: 160px;\n    margin-top: 10px;\n    \n    color: #ffff;\n    font-size: 11px;\n    \n\n}\n\n.font{\n    font-size: 22px;\n    margin-right: 90px;\n}\n\n.submit-container{\n    display: flex;\n    gap: 30px;\n    margin: 60px;\n}\n\n.submit{\n    display: flex;\n    width: 180px;\n    height: 42px;\n    color: #eaeaea;\n    background: hsl(195, 71%, 31%);\n    font-size: 19px;\n    border-radius: 50px;\n    margin-top: -20px;\n      \n}\n\n/* .button{\n    border: none;\n  color: #ffffff;\n  background-color: #176B87;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  margin: 4px 2px;\n  cursor: pointer;\n  margin-top: -48px;\n  height: 35px;\n  width: 300px !important;\n  border-radius: 15px;\n} */\n\n.button{\n    background-color: #176B87; \n    appearance: button;\n    backface-visibility: hidden;\n    \n    border-radius: 6px;\n    border-width: 0;\n    box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset,rgba(50, 50, 93, .1) 0 2px 5px 0,rgba(0, 0, 0, .07) 0 1px 1px 0;\n    box-sizing: border-box;\n    color: #fff;\n    cursor: pointer;\n    font-family: -apple-system,system-ui,\"Segoe UI\",Roboto,\"Helvetica Neue\",Ubuntu,sans-serif;\n    font-size: 12px;\n    height: 25px;\n    line-height: 1.15;\n    margin: 12px 0 0;\n    outline: none;\n    overflow: hidden;\n    padding: 0 25px;\n    position: relative;\n    text-align: center;\n    text-transform: none;\n    transform: translateZ(0);\n    transition: all .2s,box-shadow .08s ease-in;\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n    width: 212px;\n    margin-left: 35px;\n    margin-top: 20px;\n}\n\n.fill{\n    color: #ffffff;\n    font-size: 6px;\n\n}\n\n.background{\n    /* background-image: url(/src/components/Login/background.png); */\n  background-size: cover;\n  background-attachment: fixed;\n  z-index: -1; \n  width: 100%;\n  height: 100vh;\n  padding-top: 4%; \n  object-fit: cover;\n}\n\n/* .text-toca{\n    font-size: 20px;\n    color: #ffffff;\n    margin-top: 80px;\n    margin-right: 40px;\n} */\n\n.label{\n    color: #ffffff;\n    margin-top: -50px;\n}\n\n.row{\n    display: flex;\n    height: 10%;\n    align-items: center;\n    margin-top: -230px;\n    color: #ffffff;\n    margin-left: 210px;\n    font-size: 18px;\n}\n\n.row-1{\n    display: flex;\n    height: 10%;\n    align-items: center;\n    margin-top: -30px;\n    color: #ffffff;\n    margin-left: 212px;\n    font-size: 10px;\n}\n\n.col{\n    flex-basis: 50%;\n}\n\n.h1{\n    font-size: 100px;\n}\n\n.p{\n    font-size: 15px;\n}\n\n.logo-ykbut{\n    width: 100px;\n    margin-right: 190px;\n    margin-top: -100px;\n    \n}\n\n/* .logo{\n    margin-top: -130px;\n} */\n\n.error {\n    color: red;\n}\n\n@media screen and (max-width:768px)  {\n    .inputs {\n        width: 75%;\n    }\n    \n}\n\n@media screen and (max-width:480px)  {\n    .inputs {\n        width: 65%;\n    }\n    \n}\n\n.txt {\n    margin-top: -52px;\n    color: #ffffff;\n    font-size: 12px;\n}\n\n.sidebar{\n    margin-top: 60px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
